import Button from "../../design/Button";
import GModal from "../../design/components/GModal";
import classes from "./BlockContactModal.module.css";

const BlockContactModal = ({
  visible,
  closeModalHandler,
  name,
  saveHandler,
}) => {
  return (
    <GModal
      heading="Block contact"
      visible={visible}
      closeModal={() => {
        closeModalHandler();
      }}
      bodyWrapperStyle={{ paddingRight: 0 }}
      bottomButtons={[
        <Button
          hierarchy="white"
          variant="outlined"
          buttonText="Cancel"
          onClick={() => {
            closeModalHandler();
          }}
        />,
        <Button
          hierarchy="white"
          variant="outlined"
          buttonText="Block"
          buttonStyle={{ color: "#E22D20" }}
          onClick={saveHandler}
        />,
      ]}
      body={
        <p className={classes.body}>
          Are you sure you want to block <span>{name}?</span> They won't be able
          to message you anymore.
        </p>
      }
    />
  );
};

export default BlockContactModal;
